import { render, staticRenderFns } from "./BannerHome.vue?vue&type=template&id=a513bc18&scoped=true"
import script from "./BannerHome.vue?vue&type=script&lang=js"
export * from "./BannerHome.vue?vue&type=script&lang=js"
import style0 from "./BannerHome.vue?vue&type=style&index=0&id=a513bc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a513bc18",
  null
  
)

export default component.exports